import SurveysAdapter from './base';

export default class Response extends SurveysAdapter {
  modelNamePlural = 'responses';
}
